__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "13.3.12", () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(8987))))));
			register("@angular/common", "13.3.12", () => (__webpack_require__.e(129).then(() => (() => (__webpack_require__(4666))))));
			register("@angular/core", "13.3.0", () => (__webpack_require__.e(560).then(() => (() => (__webpack_require__(2560))))));
			register("@angular/platform-browser/animations", "13.3.0", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(9906))))));
			register("@angular/platform-browser", "13.3.0", () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(4497))))));
			register("@angular/router", "13.3.0", () => (__webpack_require__.e(67).then(() => (() => (__webpack_require__(124))))));
			register("@fortawesome/angular-fontawesome", "0.10.2", () => (__webpack_require__.e(775).then(() => (() => (__webpack_require__(3505))))));
			register("@fortawesome/free-solid-svg-icons", "6.2.0", () => (__webpack_require__.e(306).then(() => (() => (__webpack_require__(9306))))));
			register("@ngx-etalent-core", "1.130.10", () => (__webpack_require__.e(158).then(() => (() => (__webpack_require__(2158))))));
			register("ngx-etalent-core", "1.130.10", () => (__webpack_require__.e(439).then(() => (() => (__webpack_require__(5073))))));
			register("rxjs/operators", "7.5.0", () => (__webpack_require__.e(733).then(() => (() => (__webpack_require__(6733))))));
			register("rxjs", "7.5.0", () => (__webpack_require__.e(185).then(() => (() => (__webpack_require__(8185))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};